import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import SwitchMUI from "@mui/material/Switch";
import { createTheme, ThemeProvider } from "@mui/material";

const theme = createTheme({
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          margin: 0,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontSize: "0.85rem",
          fontWeight: 700,
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        root: {
          "& .MuiSwitch-switchBase": {
            "& .MuiSwitch-thumb": {
              color: "white",
              border: "1px solid grey",
            },
            "&.Mui-focusVisible": {
              color: "#707070",
            },
            ":hover": {
              backgroundColor: "rgba(112, 112, 112, 0.2)",
            },
          },
          "& .MuiSwitch-switchBase.Mui-checked": {
            "& .MuiSwitch-thumb": {
              color: "white",
              border: "1px solid #434DF9",
            },
            "& + .MuiSwitch-track": {
              opacity: 1,
              backgroundColor: "#434DF9",
            },
            "&.Mui-focusVisible": {
              color: "#434DF9",
            },
            ":hover": {
              backgroundColor: "rgba(2, 0, 2, 0.12)",
            },
          },
          "& .MuiSwitch-thumb": {
            border: "1px solid grey",
          },
          "& .MuiSwitch-switchBase:hover": {
            backgroundColor: "rgba(2, 0, 2, 0.12)",
          },
        },
      },
    },
  },
});

const Switch = React.forwardRef((props, ref) => {
  const {
    id,
    checked,
    name,
    sx,
    label = "",
    labelPlacement = "end",
    onChange = () => {},
    onFocus = () => {},
    inputProps = {},
    // value,
    disableRipple,
    disabled,
  } = props;
  return (
    <ThemeProvider theme={theme}>
      <FormControlLabel
        labelPlacement={labelPlacement}
        label={label}
        control={
          <SwitchMUI
            id={id}
            name={name}
            sx={sx}
            inputRef={ref}
            checked={checked}
            onChange={onChange}
            onFocus={onFocus}
            inputProps={inputProps}
            // value={value}
            disableRipple={disableRipple}
            disabled={disabled}
          />
        }
      />
    </ThemeProvider>
  );
});

export default Switch;
